import {DomainObject, oneOf} from 'shared/store';
import { observable, makeObservable } from 'mobx';
import {Employee} from 'main/stores/employees';

class BenefitUpdate extends DomainObject {
  id;
  action;
  company;
  employee;
  createdAt;
  changes;
  status;
  comment;

  _relations = {
    employee: Employee,
    action: oneOf(['employee_onboarded', 'employee_updated', 'employee_terminated', 'employee_reactivated', 'employee_enrolled'])
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      action: observable,
      company: observable,
      employee: observable,
      createdAt: observable,
      changes: observable,
      status: observable,
      comment: observable
    });

    this.merge(other);
  }
}

export default BenefitUpdate;
